import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, numberAttribute } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { BaseDrawerComponent } from '@base/base-drawer.component';
import { Tag, TAG_COLORS } from '@models';

@Component({
    selector: 'vz-select-color',
    templateUrl: './select-color-drawer.component.html',
    styleUrls: ['./select-color-drawer.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        NzDrawerModule, NzButtonModule,
    ],
})
@Tag('SelectColorDrawerComponent')
export class SelectColorDrawerComponent extends BaseDrawerComponent {
    op = input(1, { transform: numberAttribute });
    showWhite = input(false, { transform: booleanAttribute });

    colors = computed(() => this.showWhite() ? [...TAG_COLORS, '#FFFFFF'] : TAG_COLORS);
}
